import React from 'react';
import { WeatherConditions } from 'apollo/generated/client-operations';
import { getDateTime } from 'utils/dates';
import { WeatherItemMini } from 'components/weather';
import { TimelineTrackPoint } from './TimelineTrack';

/**
 * Timeline slot content.
 *
 * Displays a set of weather conditions in the track based on specific timestamps.
 */
export function TimelineWeatherConditions(props: {
  weather: WeatherConditions[];
}): React.ReactElement {
  const { weather } = props;
  return (
    <div className="odin-relative odin-min-h-[32px] odin-w-full">
      {weather.map(({ timestamp, ...rest }) => {
        const time = getDateTime({ date: timestamp, isUTC: true }).getTime();
        return (
          <TimelineTrackPoint key={`weather-item-${timestamp}`} time={time}>
            <WeatherItemMini weather={rest} />
          </TimelineTrackPoint>
        );
      })}
    </div>
  );
}
